let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("hu7f4")).then(() => parcelRequire('5XrRK'));